import { useLayoutEffect, useRef } from "react";
import { TextArea, type TextareaProps } from "./TextArea";

export type TextAreaAutoProps = TextareaProps;

export const TextAreaAuto = (props: TextAreaAutoProps) => {
  const ref = useRef<HTMLTextAreaElement>(null);

  useLayoutEffect(() => {
    if (!ref.current) return;

    ref.current.style.height = ref.current.scrollHeight + 1 + "px";
  }, []);

  return <TextArea {...props} ref={ref} />;
};
